import React, { useState } from 'react';

import { countryFlagState, countryFlagUrl } from 'services/lei/leiCountryFlag';

interface ICountryFlagProps {
    code: string;
}

/**
 * GLEIF country flag (static file, lazy - see services/lei/leiCountryFlag).
 * - empty code           -> renders nothing
 * - known missing file   -> the code is shown instead and no request is sent
 * - otherwise the <img> is lazy + async, the request is warmed up during idle time,
 *   so the table data is never blocked by flags; a failed render falls back to the code
 */
const CountryFlag: React.FC<ICountryFlagProps> = ({ code }) => {
    const normalized = code.trim().toUpperCase();
    const [failed, setFailed] = useState(false);

    if (!normalized) return null;
    if (failed || countryFlagState(normalized) === 'missing') {
        return <span className="country-flag-fallback">{normalized}</span>;
    }

    return (
        <img
            className="country-flag"
            src={countryFlagUrl(normalized)}
            alt=""
            loading="lazy"
            decoding="async"
            onError={() => setFailed(true)}
        />
    );
};

export default CountryFlag;
